import { DateTime } from 'luxon'
import { Stack, Paper, IconButton, Typography } from '@mui/material'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'

type TProps = {
  daySelected: DateTime
  onSelectDay: (day: DateTime) => void
}

export function DaySelector({ daySelected, onSelectDay }: TProps) {
  return (
    <Paper
      elevation={2}
      sx={{
        px: 2,
        py: 1,
        borderRadius: 3,
        display: 'inline-block',
      }}
    >
      <Stack direction="row" alignItems="center" spacing={2}>
        <IconButton
          onClick={() => onSelectDay(daySelected.minus({ days: 1 }))}
          sx={{
            bgcolor: 'grey.100',
            '&:hover': { bgcolor: 'grey.200' },
          }}
        >
          <ChevronLeft />
        </IconButton>

        <Typography
          variant="h6"
          sx={{
            minWidth: 120,
            textAlign: 'center',
            fontWeight: 600,
          }}
        >
          {daySelected.toFormat('dd/MM/yyyy')}
        </Typography>

        <IconButton
          onClick={() => onSelectDay(daySelected.plus({ days: 1 }))}
          sx={{
            bgcolor: 'grey.100',
            '&:hover': { bgcolor: 'grey.200' },
          }}
        >
          <ChevronRight />
        </IconButton>
      </Stack>
    </Paper>
  )
}
